const transactions = [
    {
        "id": "01e39a9c-a4ff-3429-a079-968ad1bbb0a3",
        "description": "حوالة بنكية إلى مستفيد في بنك البلاد ينتهي الايبان بـ",
        "amount": -3200.00,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-09-31T00:00:00Z",
        "insights": {
            "description_cleansed": "WIRE TRANSFER ABLIAD IBAN",
            "category": "TRANSFERS",
            "category_confidence": 0.99,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "1f72f549-ea3c-3459-a71a-5440393e2b62",
        "description": "إيداع راتب",
        "amount": 12000.00,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-09-06T00:00:00Z",
        "insights": {
            "description_cleansed": "SALARY",
            "category": "SALARY_REVENUE",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "1f72f549-ea3c-3459-a71a-5440393e2b62",
        "description": "مشتريات mcdonalds مدينة الرياض مدى نقاط بيع",
        "amount": -19.49,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-08-06T00:00:00Z",
        "insights": {
            "description_cleansed": "MCDONALDS",
            "category": "RESTAURANTS_DINING",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "e0dbc14e-2377-3b25-b57b-af48622b939a",
        "description": "إيداع في البطاقة الائتمانية",
        "amount": -200.00,
        "currency_code": "SAR",
        "pending": true,
        "timestamp": "2022-07-18T00:00:00Z",
        "insights": {
            "description_cleansed": "CREDIT CARD TOPUP",
            "category": "TRANSFERS",
            "category_confidence": 1,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "0426f10f-6c64-3368-8180-e402446789d3",
        "description": "مشتريات اونلاين فيزا booking.com",
        "amount": -900.00,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-06-23T00:00:00Z",
        "insights": {
            "description_cleansed": "BOOKING.COM",
            "category": "TRAVEL",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "06801fd6-9bc4-340b-9367-de097deec5ec",
        "description": "محطات ارامكو للبنزين مدى نقاط بيع",
        "amount": -56.32,
        "currency_code": "SAR",
        "pending": true,
        "timestamp": "2022-06-17T00:00:00Z",
        "insights": {
            "description_cleansed": "ARAMCO",
            "category": "RENT_AND_SERVICES",
            "category_confidence": 0.71,
            "type": "CARD",
            "type_confidence": 0.99
        }
    },
    {
        "id": "578b5f6c-f64e-3832-a86a-157a6a82682a",
        "description": "جافا تايم مشتريات مدى نقاط بيع",
        "amount": -16.63,
        "currency_code": "SAR",
        "pending": true,
        "timestamp": "2022-05-26T00:00:00Z",
        "insights": {
            "description_cleansed": "JAVA",
            "category": "RESTAURANTS_DINING",
            "category_confidence": 0.96,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "e49cef5e-5770-3261-be7e-b03f58a87052",
        "description": "سداد قرض قسط شهري",
        "amount": -900.00,
        "currency_code": "SAR",
        "pending": true,
        "timestamp": "2022-05-13T00:00:00Z",
        "insights": {
            "description_cleansed": "LOAN REPAYMENT",
            "category": "LOANS_AND_INVESTMENTS",
            "category_confidence": 1,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "00d8e574-5faf-38a5-8182-5d1faf81cffb",
        "description": "اشتراك نتفلكس شهري اونلاين فيزا",
        "amount": -42.00,
        "currency_code": "SAR",
        "pending": true,
        "timestamp": "2022-05-09T00:00:00Z",
        "insights": {
            "description_cleansed": "NETFLIX SUBSCRIPTION",
            "category": "ENTERTAINMENT",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "76965310-9436-38b8-ac87-671e0639854b",
        "description": "مشتريات سوا اونلاين فيزا",
        "amount": -12.99,
        "currency_code": "SAR",
        "pending": true,
        "timestamp": "2022-04-15T00:00:00Z",
        "insights": {
            "description_cleansed": "STC SAWA",
            "category": "ENTERTAINMENT",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "5192a3e5-b6f0-38d3-afba-d0040fd2b7cb",
        "description": "ابل اشتراك شهري اي كلاود فيزا اونلاين",
        "amount": -23.00,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-03-22T00:00:00Z",
        "insights": {
            "description_cleansed": "APPLE SUBSCRIPTION",
            "category": "RENT_AND_SERVICES",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "5192a3e5-b6f0-38d3-afba-d0040fd2b7cb",
        "description": "جاهز مشتريات اونلاين مدى",
        "amount": -55.00,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-03-22T00:00:00Z",
        "insights": {
            "description_cleansed": "JAHEZ",
            "category": "ENTERTAINMENT",
            "category_confidence": 0.63,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "5192a3e5-b6f0-38d3-afba-d0040fd2b7cb",
        "description": "امازون مشتريات اونلاين فيزا",
        "amount": -91.00,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-03-22T00:00:00Z",
        "insights": {
            "description_cleansed": "AMAZON",
            "category": "OTHER",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "5192a3e5-b6f0-38d3-afba-d0040fd2b7cb",
        "description": "تمارا مشتريات اونلاين مدى",
        "amount": -200.00,
        "currency_code": "SAR",
        "pending": false,
        "timestamp": "2022-03-22T00:00:00Z",
        "insights": {
            "description_cleansed": "TAMARA",
            "category": "RETAIL",
            "category_confidence": 1,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    }
]

export default transactions